var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem6C(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m89.789 143.19v-29.115h572.68v29.115h-572.68z",
    fill: "#bfbfbf",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.947 143.91v-30.92h574.6v30.92h-574.6m1.6843-28.874v27.19h570.87v-27.19h-570.87zm79.645 125.6v-74.712h5.5342v74.712h-5.5342z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.36 175.19c7.4592-9.3842 13.475-20.092 17.806-32.002 4.2108 11.911 10.106 22.618 17.806 32.002l-17.806-6.4967-17.806 6.4967zm138.84 65.449v-74.712h5.5342v74.712h-5.5342z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.28 175.19c7.4592-9.3842 13.475-20.092 17.806-32.002 4.2108 11.911 10.106 22.618 17.806 32.002l-17.806-6.4967-17.806 6.4967zm102.14 65.449v-74.712h5.5342v74.712h-5.5342z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.26 175.19c7.5795-9.3842 13.475-20.092 17.806-32.002 4.3312 11.911 10.347 22.618 17.806 32.002l-17.806-6.4967-17.806 6.4967zm96.368 65.449v-74.712h5.5342v74.712h-5.5342z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m447.47 175.19c7.5795-9.3842 13.475-20.092 17.806-32.002 4.3312 11.911 10.347 22.618 17.806 32.002l-17.806-6.4967-17.806 6.4967z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.2032 0 0 1.203 -81.065 -44.464)",
    x: 155.38711,
    y: 55.95817,
    fontFamily: "'ArialMT'",
    fontSize: "16.646px",
    stroke: "null"
  }, "1 TON"), /*#__PURE__*/React.createElement("path", {
    d: "m122.75 41.885c0.84217-8.6623 5.5342-13.234 14.197-14.076 8.6623 0.72186 13.234 5.4139 14.076 14.076-0.72186 8.6623-5.4139 13.354-14.076 14.197-8.6623-0.84217-13.354-5.6546-14.197-14.197m5.7749 0c0.48124 5.053 3.3687 7.8201 8.4217 8.1811 4.9327-0.48124 7.6998-3.2484 8.1811-8.1811-0.48124-4.9327-3.2484-7.6998-8.1811-8.1811-5.1733 0.36093-7.9404 3.1281-8.4217 8.1811z",
    fill: "#fff",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.07 26.726c9.1436 0.84217 14.197 5.8952 15.159 15.159-0.84217 9.3842-5.8952 14.437-15.159 15.4-9.3842-0.84217-14.437-6.0155-15.4-15.4 0.84217-9.2639 6.0155-14.317 15.4-15.159m-13.114 15.159c0.12031 3.6093 1.4437 6.7374 3.7296 9.3842 2.6468 2.4062 5.6546 3.6093 9.3842 3.7296 3.6093-0.12031 6.617-1.4437 9.1436-3.7296 2.5265-2.6468 3.7296-5.6546 3.7296-9.3842s-1.2031-6.7374-3.7296-9.1436c-2.5265-2.5265-5.5342-3.7296-9.1436-3.7296s-6.7374 1.2031-9.3842 3.7296c-2.4062 2.4062-3.6093 5.4139-3.7296 9.1436m22.378 0c-0.48124 5.6546-3.6093 8.7826-9.3842 9.3842-5.8952-0.60155-9.0232-3.7296-9.6248-9.3842 0.48124-5.6546 3.7296-8.7826 9.6248-9.3842 5.7749 0.48124 8.9029 3.6093 9.3842 9.3842m-4.2108 5.053c1.2031-1.4437 1.925-3.1281 2.0453-5.1733-0.12031-2.0453-0.72186-3.7296-2.0453-5.1733-1.3234-1.3234-3.0078-2.0453-5.1733-2.0453-4.4515 0.36093-6.8577 2.7671-7.3389 7.0983 0.12031 2.0453 0.84217 3.7296 2.1656 5.1733 1.3234 1.3234 3.0078 2.0453 5.1733 2.0453 2.1656 0.12031 3.8499-0.60155 5.1733-1.925z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.406 113.95 16.723-71.825h48.124l16.482 71.825h-81.329z",
    fill: "#fff",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.85 40.922v0.84217l16.964 73.269h-83.856l17.084-74.111h49.808m-64.125 71.945h78.322l-15.881-69.659h-46.319l-16.122 69.659z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m623.24 77.978c0.48124-4.2108 2.7671-6.617 6.8577-7.0983 4.3312 0.48124 6.7374 2.7671 7.0983 7.0983-0.36093 4.3312-2.7671 6.7374-7.0983 7.0983-4.0905-0.36093-6.3764-2.7671-6.8577-7.0983m2.8874 0c0.24062 2.6468 1.564 3.9702 3.9702 4.2108 2.6468-0.24062 4.0905-1.6843 4.2108-4.2108-0.12031-2.4062-1.564-3.7296-4.2108-3.9702-2.4062 0.12031-3.7296 1.4437-3.9702 3.9702z",
    fill: "#fff",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.45 249.18c2.8874-2.8874 6.2561-4.3312 10.347-4.3312s7.5795 1.4437 10.467 4.3312 4.3312 6.3764 4.3312 10.467-1.4437 7.5795-4.3312 10.467-6.3764 4.3312-10.467 4.3312-7.4592-1.4437-10.347-4.3312-4.3312-6.3764-4.3312-10.467 1.4437-7.5795 4.3312-10.467z",
    fill: "#369",
    fillOpacity: 0.502,
    stroke: "null"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.202 0 0 1.2042 -81.065 -43.464)",
    x: 450.76129,
    y: 256.39342,
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px",
    stroke: "null",
    strokeWidth: 0.99905
  }, "4"), /*#__PURE__*/React.createElement("path", {
    d: "m373.72 249.18c2.8874-2.8874 6.2561-4.3312 10.347-4.3312s7.5795 1.4437 10.467 4.3312 4.3312 6.3764 4.3312 10.467-1.4437 7.5795-4.3312 10.467-6.3764 4.3312-10.467 4.3312-7.4592-1.4437-10.347-4.3312-4.3312-6.3764-4.3312-10.467 1.4437-7.5795 4.3312-10.467z",
    fill: "#369",
    fillOpacity: 0.502,
    stroke: "null"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.202 0 0 1.2042 -81.065 -43.464)",
    x: 383.59729,
    y: 256.39342,
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px",
    stroke: "null",
    strokeWidth: 0.99905
  }, "3"), /*#__PURE__*/React.createElement("path", {
    d: "m286.62 249.18c2.8874-2.8874 6.2561-4.3312 10.347-4.3312s7.5795 1.4437 10.467 4.3312 4.3312 6.3764 4.3312 10.467-1.4437 7.5795-4.3312 10.467-6.3764 4.3312-10.467 4.3312-7.4592-1.4437-10.347-4.3312-4.3312-6.3764-4.3312-10.467 1.4437-7.5795 4.3312-10.467z",
    fill: "#369",
    fillOpacity: 0.502,
    stroke: "null"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.202 0 0 1.2042 -81.065 -43.464)",
    x: 311.17929,
    y: 256.39342,
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px",
    stroke: "null",
    strokeWidth: 0.99905
  }, "2"), /*#__PURE__*/React.createElement("path", {
    d: "m161.61 249.18c2.8874-2.8874 6.2561-4.3312 10.347-4.3312s7.5795 1.4437 10.467 4.3312 4.3312 6.3764 4.3312 10.467-1.4437 7.5795-4.3312 10.467-6.3764 4.3312-10.467 4.3312-7.4592-1.4437-10.347-4.3312-4.3312-6.3764-4.3312-10.467 1.4437-7.5795 4.3312-10.467z",
    fill: "#369",
    fillOpacity: 0.502,
    stroke: "null"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.202 0 0 1.2042 -81.065 -43.464)",
    x: 207.13029,
    y: 256.39342,
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px",
    stroke: "null",
    strokeWidth: 0.99905
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.2032 0 0 1.203 -81.065 -44.464)",
    x: 546.99711,
    y: 56.00217,
    fontFamily: "'ArialMT'",
    fontSize: "16.646px",
    stroke: "null"
  }, "1 TON"), /*#__PURE__*/React.createElement("path", {
    d: "m594.75 41.936c0.84217-8.6623 5.5342-13.234 14.197-14.076 8.6623 0.72186 13.234 5.4139 14.076 14.076-0.72186 8.6623-5.4139 13.354-14.076 14.197-8.6623-0.84217-13.354-5.6546-14.197-14.197m5.7749 0c0.48124 5.053 3.3687 7.8201 8.4217 8.1811 4.9327-0.48124 7.6998-3.2484 8.1811-8.1811-0.48124-4.9327-3.2484-7.6998-8.1811-8.1811-5.1733 0.36093-7.9404 3.1281-8.4217 8.1811z",
    fill: "#fff",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609.07 26.777c9.1436 0.84217 14.197 5.8952 15.159 15.159-0.84217 9.3842-5.8952 14.437-15.159 15.4-9.3842-0.84217-14.437-6.0155-15.4-15.4 0.84217-9.2639 6.0155-14.317 15.4-15.159m-13.114 15.159c0.12031 3.6093 1.4437 6.7374 3.7296 9.3842 2.6468 2.4062 5.6546 3.6093 9.3842 3.7296 3.6093-0.12031 6.617-1.4437 9.1436-3.7296 2.5265-2.6468 3.7296-5.6546 3.7296-9.3842s-1.2031-6.7374-3.7296-9.1436c-2.5265-2.5265-5.5342-3.7296-9.1436-3.7296s-6.7374 1.2031-9.3842 3.7296c-2.4062 2.4062-3.6093 5.4139-3.7296 9.1436m22.378 0c-0.48124 5.6546-3.6093 8.7826-9.3842 9.3842-5.8952-0.60155-9.0232-3.7296-9.6248-9.3842 0.48124-5.6546 3.7296-8.7826 9.6248-9.3842 5.7749 0.48124 8.9029 3.6093 9.3842 9.3842m-4.2108 5.053c1.2031-1.4437 1.925-3.1281 2.0453-5.1733-0.12031-2.0453-0.72186-3.7296-2.0453-5.1733-1.3234-1.3234-3.0078-2.0453-5.1733-2.0453-4.4515 0.36093-6.8577 2.7671-7.3389 7.0983 0.12031 2.0453 0.84217 3.7296 2.1656 5.1733 1.3234 1.3234 3.0078 2.0453 5.1733 2.0453 2.1656 0.12031 3.8499-0.60155 5.1733-1.925z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m568.4 114 16.723-71.825h48.124l16.482 71.825h-81.329z",
    fill: "#fff",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m633.85 40.974v0.84217l16.964 73.269h-83.856l17.084-74.111h49.808m-64.125 71.945h78.322l-15.881-69.659h-46.319l-16.122 69.659z",
    stroke: "null"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem6C);
export default __webpack_public_path__ + "static/media/item6c.8b2c147976ad033afbac32d7ca660e97.svg";
export { ForwardRef as ReactComponent };